goog.provide("shadow.js.shim.module$date_fns");
goog.provide("module$shadow_js_shim_module$date_fns");
shadow.js.shim.module$date_fns = shadow.js.nativeProvides["date-fns"] = shadow$bridge("date-fns");
module$shadow_js_shim_module$date_fns.default = shadow.js.shim.module$date_fns;
